'use client';

import { useServerContext } from '@/context/server';
import { useMedia } from 'react-use';

const useIsMobile = () => {
  const { isMobileOnServer } = useServerContext();

  const isDesktop = useMedia('(min-width: 960px)', !isMobileOnServer);

  return !isDesktop;
};

export default useIsMobile;
